module.exports = __webpack_public_path__ + "img/weibo.d36e4572.png";